import { httpClient } from './httpClient';

const base = '/api/interesados';

export const listarInteresados = (params = {}) => {
  const entries = Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== '' && v !== 'all');
  const qs = new URLSearchParams(entries.map(([k, v]) => [k, String(v)])).toString();
  return httpClient.get(`${base}${qs ? `?${qs}` : ''}`);
};
export const crearInteresado = (payload) => httpClient.post(base, payload);
export const obtenerInteresado = (id) => httpClient.get(`${base}/${id}`);
export const buscarPorDocumento = (documento = "") => {
  const query = new URLSearchParams({ documento }).toString();
  return httpClient.get(`${base}/buscar?${query}`);
};
export const actualizarInteresado = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarInteresado = (id) => httpClient.del(`${base}/${id}`);
export const cambiarEstadoInteresado = (id, nuevo_estado) =>
  httpClient.patch(`${base}/${id}/estado`, { nuevo_estado });
export const convertirAEstudiante = (id, payload = {}) =>
  httpClient.post(`${base}/${id}/convertir`, payload);

const interesadosService = {
  listar: listarInteresados,
  crear: crearInteresado,
  obtener: obtenerInteresado,
  buscarPorDocumento,
  actualizar: actualizarInteresado,
  eliminar: eliminarInteresado,
  cambiarEstado: cambiarEstadoInteresado,
  convertir: convertirAEstudiante,
};

export default interesadosService;
